import { defineMessages } from 'react-intl';

export const servicePlanCategoriesMessages = defineMessages({
    servicePlanCategories: {
        id: 'service-plan-categories',
        defaultMessage: 'Service plan categories',
    },
    categories: {
        id: 'categories',
        defaultMessage: 'Categories',
    },
    category: {
        id: 'category',
        defaultMessage: 'Category',
    },
    createServicePlanCategorySuccess: {
        id: 'create-service-plan-category-success',
        defaultMessage: 'Service plan category created',
    },
    createServicePlanCategorySuccessDescription: {
        id: 'create-service-plan-category-success-description',
        defaultMessage: 'Service plan category {entry} has been successfully created.',
    },
    addServicePlanCategorySubtitle: {
        id: 'add-service-plan-category-subtitle',
        defaultMessage: 'Create a new service plan category',
    },
    deleteServicePlanCategory: {
        id: 'delete-service-plan-category',
        defaultMessage: 'Delete service plan category',
    },
    deleteServicePlanCategorySuccess: {
        id: 'delete-service-plan-category-success',
        defaultMessage: 'Service plan category deleted',
    },
    deleteServicePlanCategorySuccessDescription: {
        id: 'delete-service-plan-category-success-description',
        defaultMessage: 'The service plan category has been successfully deleted.',
    },
    confirmDeleteServicePlanCategory: {
        id: 'confirm-delete-service-plan-category',
        defaultMessage: 'Are you sure you want to delete this service plan category? This action cannot be undone.',
    },
    deleteServicePlanCategorySubtitle: {
        id: 'delete-service-plan-category-subtitle',
        defaultMessage: 'Permanently delete service plan category {entity}',
    },
    editServicePlanCategorySubtitle: {
        id: 'edit-service-plan-category-subtitle',
        defaultMessage: 'Edit service plan category {entity}',
    },
    updateServicePlanCategorySuccess: {
        id: 'update-service-plan-category-success',
        defaultMessage: 'Service plan category updated',
    },
    updateServicePlanCategorySuccessDescription: {
        id: 'update-service-plan-category-success-description',
        defaultMessage: 'Service plan category {entity} has been successfully updated.',
    },
});